module.exports = __webpack_public_path__ + "static/media/cta-shape.69e485e0.png";